import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/goods-list/[id]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/goods-list/[id]/page.csr.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/goods-list/components/SeoContentCarousel.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
